import { Component, computed, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Highlight } from 'ngx-highlightjs';
import { AlertComponent } from '@bn/web-ui/alert/alert.component';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';
import { ButtonComponent } from '@bn/web-ui/button';
import { BnClipboardService } from '@bn/web-ui/common-web/services';
import { FlagComponent } from '@bn/web-ui/flag';
import { eventLogMethodColor, EventRowLogContext } from '../../../../models';
import { EventRow } from '../../../../openapi';
import { WafService } from '../../../../services/waf.service';

@Component({
  selector: 'app-app-shield-event-logs-row-detail',
  templateUrl: './event-logs-row-detail.component.html',
  styleUrls: ['./event-logs-row-detail.component.scss'],
  imports: [AlertComponent, BadgeComponent, ButtonComponent, FaIconComponent, FlagComponent, Highlight],
})
export class EventLogsRowDetailComponent {
  readonly row = input.required<EventRow>();

  readonly methodColor = eventLogMethodColor;

  readonly #clipboard = inject(BnClipboardService);
  readonly #wafService = inject(WafService);

  readonly fields = computed<Record<string, string>>(() => this.row().fields ?? {});
  readonly log = computed<EventRowLogContext>(() => (this.row().log ?? {}) as EventRowLogContext);
  readonly url = computed(() => this.log().Url ?? this.fields()['url'] ?? '');

  readonly safeUrl = computed<string | null>(() => {
    const raw = this.url();

    if (!raw) return null;

    try {
      const parsed = new URL(raw);

      return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.toString() : null;
    } catch {
      return null;
    }
  });

  readonly ruleId = computed(() => this.fields()['ruleId'] ?? '');
  readonly isWafRule = computed(() => this.fields()['feature'] === 'WAF');
  readonly isRuleBlocking = computed(() => this.#wafService.isRuleBlocking(this.ruleId()));

  copyJa4(): void {
    const ja4 = this.fields()['ja4'];

    if (ja4) this.#clipboard.copyTextToClipboard(ja4, 'JA4 fingerprint');
  }

  logOnlyRule(): void {
    this.#wafService.logRules([this.ruleId()]);
  }

  disableRule(): void {
    this.#wafService.disableRules([this.ruleId()]);
  }

  enableRule(): void {
    this.#wafService.enableRules([this.ruleId()]);
  }
}
